import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_barcode } from "./shared/data.service";

import { wsBarcodeManagementBarcodeInfo } from "./shared/wsBarcodeManagementBarcodeInfo";

import { StatusComponent } from "./status/status.component";
import { StatusMTAComponent } from "./statusmta/statusmta.component";

import { ViewChild } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./barcode.component.html",
	styleUrls: ["./barcode.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class BarcodeComponent implements OnInit, OnDestroy {
	@ViewChild("mydt") mydt: Table;
	@ViewChild("filterCardName", { static: false })
	public filterCardName: Dropdown;
	@ViewChild("filterCardStock", { static: false })
	public filterCardStock: Dropdown;
	@ViewChild("filterCardStatus", { static: false })
	public filterCardStatus: Dropdown;

	constructor(
		private datepipe: DatePipe,
		private dataService: DataService_barcode,
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any; // From Person Selector

	//	Barcode List
	public lstBarcodes: wsBarcodeManagementBarcodeInfo[] = [];
	public SelectedBarcodeItem: wsBarcodeManagementBarcodeInfo;

	//	Filters
	public isShowEmbeddedID: boolean = false;
	public isShowExpireDate: boolean = false;
	public lstCardNames: any = [];
	public lstCardStocks: any = [];
	public lstCardStatuses: any = [];

	public pagefirst: number = 0;
	public pagerows: number = 25;

	public PublicTransitLabel: string = "MTA";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.isBusy = true;
			this.dataService
				.BarcodeManagementBarcodeSelectList(this.SelectedPerson.PersonID)
				.subscribe((data) => this.BarcodeManagementBarcodeSelectList_Complete(data));
		});

		this.dataService.PublicTransitPreferenceSelect().subscribe((data: any) => {
			if (data.Success == true) {
				this.PublicTransitLabel = data.ErrorMessage;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		this.isBusy = true;
		this.dataService
			.BarcodeManagementBarcodeSelectList(this.SelectedPerson.PersonID)
			.subscribe((data) => this.BarcodeManagementBarcodeSelectList_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementBarcodeSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementBarcodeSelectList_Complete(data: any) {
		this.lstBarcodes = data;
		this.SelectedBarcodeItem = null;

		//
		//	Set Filter Lists
		//
		this.lstCardNames = Array.from(new Set(this.lstBarcodes.map((item: any) => item.CardName)));
		this.lstCardStocks = Array.from(new Set(this.lstBarcodes.map((item: any) => item.IDCardStockDesc)));
		this.lstCardStatuses = Array.from(new Set(this.lstBarcodes.map((item: any) => item.BarcodeStatusDesc)));

		//
		//	Reset Filters
		//
		this.onClearFilters();

		//
		//	Reset Sort
		//
		this.mydt.multiSortMeta = [];
		this.mydt.multiSortMeta.push({ field: "IssueDate", order: -1 });
		this.mydt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleEmbeddedID
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleEmbeddedID() {
		this.isShowEmbeddedID = !this.isShowEmbeddedID;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleExpireDate
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleExpireDate() {
		this.isShowExpireDate = !this.isShowExpireDate;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowSelect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowSelect(event) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRowUnselect
	//
	//-----------------------------------------------------------------------------------------------------
	onRowUnselect(event) {
		//
		//	Need to set SelectedBarcodeItem here. We don't unselect when selected.
		//
		this.SelectedBarcodeItem = event.data;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClearFilters
	//
	//-----------------------------------------------------------------------------------------------------
	onClearFilters() {
		this.filterCardName.clear(null);
		this.filterCardStock.clear(null);
		this.filterCardStatus.clear(null);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onChangeStatus
	//
	//-----------------------------------------------------------------------------------------------------
	onChangeStatus() {
		//
		//	Validate
		//
		if (this.SelectedBarcodeItem == null || this.SelectedBarcodeItem.IDCardID < 1) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a card",
				header: "Change Status",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
			return;
		}

		//
		//	Is This an MTA Card?
		//
		if (this.SelectedBarcodeItem.IsMTA == true) {
			//
			//   If MTA barcode is deactivated users cannot change the status
			//
			if (this.SelectedBarcodeItem.IDStatusID != 0) {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "The selected barcode cannot be edited, because it has already been deactivated.",
					header: "Change Status",
					icon: "fa fa-info",
					accept: () => {},
					reject: () => {},
				});
				return;
			}
			//
			//	Display Popup
			//
			var ref = this.dialogService.open(StatusMTAComponent, {
				header: "Change Status (" + this.PublicTransitLabel + ")",
				width: "435px",
				data: {
					UserPersonID: this.user.personID,
					IDCardID: this.SelectedBarcodeItem.IDCardID,
					IDStatusID: this.SelectedBarcodeItem.IDStatusID,
					Barcode: this.SelectedBarcodeItem.CAASSBarcode,
					UID: this.SelectedBarcodeItem.UID,
					PublicTransitLabel: this.PublicTransitLabel,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		} else {
			//
			//	Display Popup
			//
			var ref = this.dialogService.open(StatusComponent, {
				header: "Change Status",
				width: "435px",
				data: {
					UserPersonID: this.user.personID,
					IDCardID: this.SelectedBarcodeItem.IDCardID,
					IDStatusID: this.SelectedBarcodeItem.IDStatusID,
					Barcode: this.SelectedBarcodeItem.CAASSBarcode,
					UID: this.SelectedBarcodeItem.UID,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
					//
					//	Refresh Q
					//
					this.onRefresh();
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
